import { apolloClient } from '@/services/apollo-client'
import { ADD_POINT, DEDUCT_POINT } from '@/graphql-toto/POINT'


export const addPointApi = (form) => {
    return new Promise(async (resolve, reject) => {
        try {
            const res = await apolloClient.mutate({
                mutation: ADD_POINT,
                variables: form
            })
            resolve(res.data.addPointToEmployer)
        } catch (e) {
            reject(e)
        }
    })
}

export const deductPointApi = (form) => {
    return new Promise(async (resolve, reject) => {
        try {
            const res = await apolloClient.mutate({
                mutation: DEDUCT_POINT,
                variables: form
            })
            resolve(res.data.deductPoint)
        } catch (e) {
            reject(e)
        }
    })
}